var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height"},[(_vm.threads.length > 0)?_c('w-list',{attrs:{"threads":_vm.threads}}):_c('w-empty')],1)}
var staticRenderFns = []

export { render, staticRenderFns }